import React from "react";
import Autopara from "../Autopara/Autopara";

const images = [
  "https://media.istockphoto.com/id/1331493599/photo/shot-of-a-businessman-using-a-computer-while-working-in-a-call-center.jpg?s=612x612&w=0&k=20&c=ocaFzVRnDARFnANjyd6CMrwAI0Ua6I0Na_MKej8IysA=",
  "https://images.pexels.com/photos/8867482/pexels-photo-8867482.jpeg?cs=srgb&dl=pexels-yankrukov-8867482.jpg&fm=jpg",
  "https://plus.unsplash.com/premium_photo-1661484821938-c9f8b585bd21?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8Y3VzdG9tZXIlMjBzZXJ2aWNlfGVufDB8fDB8fHww",
];

const paragraphText = `
  <strong>Customer Care Training</strong> builds expertise in 
  handling client queries, problem resolution, and maintaining customer satisfaction.<br/><br/>
  Training includes <span style="color: teal; font-weight: bold;">voice & accent</span>, 
  <span style="color: teal; font-weight: bold;">CRM tools</span>, 
  and <span style="color: teal; font-weight: bold;">customer-first approaches</span>.
`;

function AutoparaCustomerCare() {
  return <Autopara images={images} text={paragraphText} />;
}

export default AutoparaCustomerCare;
